import { createRoot } from "react-dom/client";
import * as kiwiSdk from "@huyafed/huya-kiwi";
import App from "./App";
import "@/global";
import "@/global.scss";
import { tafFetch } from "@/api/_tafFetch";
import { GAME_ID, TOOL_ID } from "@/config/env";
import logger from "@/utils/logger";

const logRuntimeInitializationError = (error: unknown) => {
  const message = "[GameToolRuntime] initialization failed";
  try {
    logger.error(message, { error });
  } catch (loggerError) {
    console.warn("[GameToolRuntime] SDK logger failed:", loggerError);
  }
  console.warn(`${message}:`, error);
};

const runtimeEnv =
  import.meta.env.MODE !== "production"
    ? "test"
    : location.origin.includes("pre")
      ? "pre"
      : "prod";

try {
  void window.GameToolRuntime
    ?.init({
      gameId: GAME_ID,
      toolId: TOOL_ID,
      env: runtimeEnv,
      tafFetch,
      sdk: kiwiSdk,
    })
    .catch(logRuntimeInitializationError);
} catch (error) {
  logRuntimeInitializationError(error);
}

createRoot(document.getElementById("root")!).render(<App />);
